module.exports = __webpack_public_path__ + "static/media/Gilroy-Thin-Italic.36d29da7.woff2";